module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('aside', {
    staticClass: "main-sidebar"
  }, [_c('section', {
    staticClass: "sidebar"
  }, [_c('ul', {
    staticClass: "sidebar-menu"
  }, [_vm._m(0), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'EditPark',
        params: {
          id: this.getParkId()
        }
      },
      "tag": "li",
      "exact": ""
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-user"
  }), _vm._v(" "), _c('span', [_vm._v("Meu Cadastro")])])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'CompaniesHome',
        params: {
          parkId: this.getParkId()
        }
      },
      "tag": "li",
      "exact": ""
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-send"
  }), _vm._v(" "), _c('span', [_vm._v("Empresas")])])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'GeneralInformations',
        params: {
          parkId: this.getParkId()
        }
      },
      "tag": "li",
      "exact": ""
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-info"
  }), _vm._v(" "), _c('span', [_vm._v("Informações Gerais")])])]), _vm._v(" "), (this.showAnswerMenu) ? _c('router-link', {
    attrs: {
      "to": {
        name: 'ParkQuiz',
        params: {
          'parkId': this.getParkId(),
          'referenceYear': this.getReferenceYear(),
          'quizUuid': this.parkQuizUuid
        }
      },
      "tag": "li",
      "exact": ""
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-question"
  }), _vm._v(" "), _c('span', [_vm._v("Responder")])])]) : _vm._e(), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'QuizReports'
      },
      "tag": "li"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-pie-chart"
  }), _vm._v("\n          Relatórios\n        ")])])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "header"
  }, [_c('strong', [_vm._v("Menu")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-328e9cdf","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/template/ParkSidebar.vue
// module id = 713
// module chunks = 1